import { BarChart, Bar, ResponsiveContainer, Tooltip } from 'recharts';

const getBarColor = (value: number) => {
  if (value >= 12) return '#4B5363';
  if (value >= 9) return '#7A8391';
  if (value >= 6) return '#9BA7B5';
  if (value >= 3) return '#BCC3CD';
  return '#DDE1E7';
};

export default function RiskChart({
  chartData,
}: {
  chartData: { label: string; value: number }[];
}) {
  return (
    <ResponsiveContainer width='100%' height={120}>
      <BarChart
        data={chartData}
        margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
        barCategoryGap='30%'
      >
        <Tooltip content={<CustomTooltip />} />
        <Bar
          dataKey='value'
          fill='#4B5363'
          radius={[12, 12, 0, 0]}
          isAnimationActive={true}
          barSize={30}
          shape={<CustomBar getColor={getBarColor} />}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

function CustomBar({ x, y, width, height, value, getColor }: any) {
  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill={getColor(value)}
      rx={12}
      ry={12}
    />
  );
}

function CustomTooltip(props: any) {
  const { active, payload } = props;
  if (!active || !payload || !payload.length) return null;

  return (
    <div
      style={{
        background: '#F8F9FB', // lighter background
        padding: '8px 12px',
        borderRadius: '8px',
        border: '1px solid #DDE1E7',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ fontWeight: 600, color: '#4B5363' }}>
        {payload[0]?.payload?.label}
      </div>
      <div style={{ color: '#4B5363', marginTop: 4 }}>{payload[0].value}%</div>
    </div>
  );
}
